export const REDACTED = '[redacted]'

const TICKET_PARAM = 'ticket'

// Also matches the percent-encoded form, since a ticket URL can travel inside another URL's query.
const TICKET_IN_TEXT = /((?:^|[?&#;\s]|%(?:25)*(?:3F|26|23))ticket(?:=|%(?:25)*3D))[^&#\s"'%<>]*/gi

export function scrubTicketText(value: string): string {
  return value.replace(TICKET_IN_TEXT, `$1${REDACTED}`)
}

function isPlainObject(value: object): value is Record<string, unknown> {
  const prototype = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null
}

function scrub(value: unknown, seen: WeakSet<object>): unknown {
  if (typeof value === 'string') {
    return scrubTicketText(value)
  }
  if (value === null || typeof value !== 'object' || seen.has(value)) {
    return value
  }
  seen.add(value)
  if (Array.isArray(value)) {
    const isTicketPair = value.length === 2 && value[0] === TICKET_PARAM && typeof value[1] === 'string'
    value.forEach((item, index) => {
      value[index] = isTicketPair && index === 1 ? REDACTED : scrub(item, seen)
    })
    return value
  }
  if (!isPlainObject(value)) {
    return value
  }
  for (const [key, item] of Object.entries(value)) {
    value[key] = key === TICKET_PARAM && typeof item === 'string' ? REDACTED : scrub(item, seen)
  }
  return value
}

/**
 * Redacts single-use Shopify connect tickets from a Sentry payload in place: they
 * arrive in the page URL, and a leaked one can still be redeemed until it expires.
 */
export function scrubTickets<T>(payload: T): T {
  return scrub(payload, new WeakSet()) as T
}
